import { loginRoute } from 'routes/routes';

/**
 * Login URL that returns the user to where they were, query string included.
 *
 * The query string is state, not decoration: a deep link from a notification
 * email carries what the destination needs to render (ai-presentations sends
 * `/presentations/templates/<deckId>/edit?tab=presentations&activity=<id>`,
 * where those two params are what opens the activity dialog). It has to be
 * encoded, or its params are parsed as params of the login URL itself and the
 * `redirect` value is truncated at the first `&`.
 */
export const loginRedirectUrl = (pathname: string, search: string): string => {
  if (pathname === loginRoute) {
    return loginRoute;
  }
  return `${loginRoute}?redirect=${encodeURIComponent(`${pathname}${search}`)}`;
};

/**
 * Same-origin path to send the user to after login, or `/`.
 *
 * Resolved with the URL parser rather than string checks because browsers
 * normalize `/\evil.com` and `/<tab>/evil.com` to `//evil.com` — a
 * protocol-relative URL that leaves the portal (ENG-1485).
 */
export const safeLoginRedirect = (redirect: string, origin: string = window.location.origin): string => {
  try {
    const url = new URL(redirect, origin);
    if (url.origin !== origin) {
      return '/';
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return '/';
  }
};
